import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { SortableContainer } from 'react-sortable-hoc';

// Actions
import { moveEntity } from '../../../../../../actions/website/EntityActions';

// Components
import EditPageSortableItem from './EditPageSortableItem';

// Styles
import './EditPageSortableList.less';

const EditPageSortableList = SortableContainer(
  ({ orderedIds = [], entities = {}, onEdit, onDelete, entityDetail, entityType }) => {
    return (
      <ul className={`edit-page-entities-list entities-list--${entityType} sortable-list`}>
        {orderedIds.map((entityId, index) => (
          <EditPageSortableItem
            entity={entities[entityId]}
            key={entityId}
            index={index}
            onEdit={onEdit}
            onDelete={onDelete}
            entityDetail={entityDetail}
            entityType={entityType}
          />
        ))}
      </ul>
    );
  }
);

const mapDispatchToProps = dispatch => ({
  onSortEnd: ({ oldIndex, newIndex }) => dispatch(moveEntity(oldIndex, newIndex)),
});

EditPageSortableList.propTypes = {
  entities: PropTypes.shape({}),
  orderedIds: PropTypes.arrayOf(PropTypes.number),
  onSortEnd: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  entityDetail: PropTypes.func,
  entityType: PropTypes.string,
};

export default connect(null, mapDispatchToProps)(EditPageSortableList);
